import { getFloatingNumber } from './getFloatingNumber';

export const getMaxSize = (logos) =>
  logos.reduce(
    (maxSize, { aspectRatio, size }) =>
      Math.max(getFloatingNumber(size * aspectRatio), maxSize),
    0
  );
